module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPresident) ? _c('action-' + _vm.type, {
    tag: "component",
    attrs: {
      "action": _vm.action
    }
  }) : _c('uikit:simple-page', [(_vm.type == 'bullet') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is assassinating someone")]) : _vm._e(), (_vm.type == 'inspect') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is investigating someone")]) : _vm._e(), (_vm.type == 'preview-deck') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is looking at the top 3 cards of the deck")]) : _vm._e(), (_vm.type == 'special-election') ? _c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("The president is choosing the next president")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36cee1d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/EXECUTIVE_ACTION/index.vue
// module id = 318
// module chunks = 0